import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../context/useAuth';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { authenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // 可以在这里显示加载状态
    return <div>Loading...</div>;
  }

  if (!authenticated) {
    // 重定向到登录页面并记录当前路径
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 